import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-bootstrap';
import { useCallback, useState } from 'react';
import { LevelRewardInput, PaidCalendarReward } from '../../../../../../__gqltypes__';
import Chip from '../../../components/Chip';
import EditRewardsModal from '../../../components/EditRewardsModal';
import { emitter } from '../../../../../../apollo';

type Props = {
  index: number;
  level: PaidCalendarReward;
  setReward: React.Dispatch<PaidCalendarReward>;
};

export const isVanityItem = new Set<string>([
  'STICKER',
  'PROFILE_FRAME',
  'APP_SKIN',
  'BADGE',
  'EMOJI',
  'EMOJI_PACK',
  'CONTENT_PACK_REWARD',
  'POSTER',
]);

export default function UpgradeForm({ index, level, setReward }: Props) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [showEditReward, setShowEditReward] = useState(false);

  const handleShowEditReward = useCallback((isEdit: boolean) => {
    setIsEditMode(isEdit);
    setShowEditReward(true);
  }, []);

  const handleAddReward = useCallback(
    (newReward: LevelRewardInput) => {
      if (!isVanityItem.has(newReward.type) && newReward.amount <= 0) {
        emitter.emit('error', [
          {
            message: `Cannot set ${newReward.amount} amount value for ${newReward.type}`,
            locations: `Day ${index + 1}`,
          },
        ]);
        setShowEditReward(false);
        return;
      }
      setReward({
        type: newReward.type,
        amount: newReward.amount,
        itemId: newReward.itemId ?? '',
        __typename: 'PaidCalendarReward',
      });
      setShowEditReward(false);
    },
    [setReward]
  );
  return (
    <Form>
      <hr />
      <h5>
        Day
        {index + 1}
      </h5>
      <Row>
        <EditRewardsModal
          isEdit={isEditMode}
          tier={null}
          show={showEditReward}
          level={index}
          reward={level as LevelRewardInput}
          handleSave={handleAddReward}
          handleClose={() => setShowEditReward(false)}
          disableCurrencySpecialEvent
          disableSubscriptionDay={false}
          disableMonthlyBuff
          enableExtendedFragmentSelector
        />
        <Col>
          <Row className="mb-3">
            <Col className="d-flex flex-column align-items-center">
              <Form.Label className="font-weight-bold">Reward</Form.Label>

              <Row className="mt-2 align-items-end">
                <Chip reward={level as LevelRewardInput} globalAction={() => handleShowEditReward(true)} />
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}
